export default "__VITE_ASSET__Cegmtirh__"